const EMBED_PLATFORM_HOSTNAMES = [
  'youtube.com',
  'youtube-nocookie.com',
  'youtu.be',
  'vimeo.com',
  'wistia.com',
  'wistia.net',
  'elevkanalen.no'
];

export function isEmbedPlatformUrl(url: string): boolean {
  if (!url) return false;

  try {
    const { hostname } = new URL(url);
    const lower = hostname.toLowerCase();
    return EMBED_PLATFORM_HOSTNAMES.some((h) => lower === h || lower.endsWith(`.${h}`));
  } catch {
    return false;
  }
}
